import { useEffect, useState, useRef, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { doc, setDoc } from "firebase/firestore";
import db from "../../../firebase";
import {
  acceptOrRejectMoneyCollection,
  getMoneyCollectionsReceiptsForUser,
  getPurchesRequestForUser,
  getTermsAndConditions,
  getUserBalanceInfoApi,
  getWhatsAppContact,
} from "../../../network";
import { toastError, toastSuccess } from "../../../helpers/toasters";
import {
  listenToAskForMoneyCounter,
  listenToUserCount,
} from "../../../firebaseService";
import { ROUTES } from "../../../constants/_routes";

export function useNavbarLogic() {
  const { authorization } = useSelector((state) => state?.auth);
  const { dir } = useSelector((state) => state.language);
  const location = useLocation();
  const navToggleBtn = useRef();

  const isAuth = authorization?.token;
  const isEmirates = authorization?.isEmirate;
  // const isEmirates = true;

  const [offerCount, setOfferCount] = useState(0);
  const [moneyCount, setMoneyCount] = useState(0);
  const [isBalanceVisible, setIsBalanceVisible] = useState(false);
  const [isPendingOrdersVisible, setIsPendingOrdersVisible] = useState(false);
  const [isPendingOrders, setIsPendingOrders] = useState(true);
  const [isOffersVisible, setIsOffersVisible] = useState(false);
  const [isMoneyVisible, setIsMoneyVisible] = useState(false);
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [showProfileDrawer, setShowProfileDrawer] = useState(false);
  const [orders, setOrders] = useState([]);
  const [purchase, setPurchase] = useState([]);
  const [moneyCollection, setMoneyCollection] = useState([]);
  const [render, setRender] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [hoverStateOnPartners, setHoverStateOnPartners] = useState(false);
  const [terms, setTerms] = useState("");
  const [showMoreBtn, setShowMoreBtn] = useState(window.innerWidth >= 992);
  const [color, setColor] = useState("#ffffff");

  const handleCloseMenu = () => {
    if (navToggleBtn.current?.getAttribute("aria-expanded") === "true") {
      navToggleBtn.current.click();
    }
  };

  const handleContact = () => {
    const windowReference = window.open();
    getWhatsAppContact(
      (res) => {
        if (res.success) {
          windowReference.location = `https://api.whatsapp.com/send?phone=${res.data}`;
        } else {
          toastError(res.message);
        }
      },
      (res) => {
        toastError(res.message);
      },
    );
  };

  const getUserBalanceInfo = () => {
    getUserBalanceInfoApi(
      (success) => {
        if (success?.success) setOrders(success.data);
        else toastError(success.message);
      },
      (fail) => {
        toastError(fail.message);
      },
    );
  };

  const purchesRequestForUser = () => {
    getPurchesRequestForUser(
      (success) => {
        if (success?.success) setPurchase(success.data);
        else toastError(success.message);
      },
      (fail) => {
        toastError(fail.message);
      },
    );
  };

  const getMoneyCollectionsReceipts = () => {
    getMoneyCollectionsReceiptsForUser(
      (success) => {
        if (success?.success) setMoneyCollection(success.data);
        else toastError(success.message);
      },
      (fail) => {
        toastError(fail.message);
      },
    );
  };

  const handleToggleBalance = () => {
    setIsBalanceVisible(true);
    getUserBalanceInfo();
  };

  const handleTogglePendingOrders = (pendingOrders) => {
    setIsPendingOrders(pendingOrders);
    setIsPendingOrdersVisible(true);
  };

  const handleRenderParents = () => setRender((prev) => !prev);

  const onCancel = () => {
    setIsBalanceVisible(false);
    setIsPendingOrdersVisible(false);
  };

  const onNotCancel = () => setShowNotificationModal(false);

  const onOffersClose = () => setIsOffersVisible(false);

  const handleShowOffers = async () => {
    setIsOffersVisible(true);
    await setDoc(
      doc(db, `users`, authorization?.userId),
      { unReadMessagesCount: 0 },
      { merge: true },
    );
    setRender((prev) => !prev);
  };

  const handleShowReceived = async () => {
    setIsMoneyVisible(true);
    await setDoc(
      doc(db, `users`, authorization?.userId),
      { unReadAskForMoneyCount: 0 },
      { merge: true },
    );
    setRender((prev) => !prev);
  };

  const handleOffer = (offer, accept) => {
    setSelectedItem({ ...offer, isAccepted: accept });
    setShowNotificationModal(true);
  };

  const handleReceivedConfirmation = (id, isAccepted) => {
    setMoneyCollection((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, isProcessing: true } : item,
      ),
    );

    acceptOrRejectMoneyCollection(
      { id, isAccepted },
      (success) => {
        setMoneyCollection((prev) => prev.filter((item) => item.id !== id));
        toastSuccess(success?.message);
        setRender((pre) => !pre);
      },
      (error) => {
        toastError(error?.message || "An error occurred!");
        setMoneyCollection((prev) =>
          prev.map((item) =>
            item.id === id ? { ...item, isProcessing: false } : item,
          ),
        );
      },
    );
  };

  const handleBuyingFromStore = () => {
    setShowNotificationModal(false);
    setIsOffersVisible(false);
  };

  useLayoutEffect(() => {
    const updateSize = () => setShowMoreBtn(window.innerWidth >= 992);
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  useEffect(() => {
    getTermsAndConditions(
      (success) => {
        if (success.success) setTerms(success.data);
        else toastError(success.message);
      },
      (fail) => {
        toastError(fail?.data?.message ?? undefined);
      },
    );
  }, [dir]);

  useEffect(() => {
    if (!authorization?.userId) return;

    const unsubscribeCount = listenToUserCount(
      authorization.userId,
      setOfferCount,
    );
    const unSubscribeMoneyCounter = listenToAskForMoneyCounter(
      authorization.userId,
      setMoneyCount,
    );

    return () => {
      unsubscribeCount();
      unSubscribeMoneyCounter();
    };
  }, [authorization]);

  useEffect(() => {
    getUserBalanceInfo();
    purchesRequestForUser();
    getMoneyCollectionsReceipts();
  }, [render, dir]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setColor(location.pathname === ROUTES.RENT_WAREHOUSE ? "green" : "#ffff");
  }, [location]);

  return {
    isAuth,
    isEmirates,
    authorization,
    dir,
    location,
    navToggleBtn,
    showMoreBtn,
    offerCount,
    moneyCount,
    isBalanceVisible,
    isPendingOrdersVisible,
    isPendingOrders,
    isOffersVisible,
    isMoneyVisible,
    setIsMoneyVisible,
    showNotificationModal,
    showProfileDrawer,
    setShowProfileDrawer,
    isTermsModalOpen,
    setIsTermsModalOpen,
    orders,
    purchase,
    moneyCollection,
    selectedItem,
    terms,
    hoverStateOnPartners,
    setHoverStateOnPartners,
    color,
    setColor,
    handleCloseMenu,
    handleContact,
    handleToggleBalance,
    handleTogglePendingOrders,
    handleRenderParents,
    onCancel,
    onNotCancel,
    onOffersClose,
    handleShowOffers,
    handleShowReceived,
    handleOffer,
    handleReceivedConfirmation,
    handleBuyingFromStore,
  };
}
